export const extractValidateErrors = ({ inner }) => inner.reduce((acc, { path, message }) => {
  acc[path] = message;

  return acc;
}, {});

export const hasValidErrors = (errors) => Boolean(errors && Object.keys(errors).length);

export const createContactRequest = (id, data) => {
  const { message, ...rest } = data;
  const investorRequest = id === 'investor';
  const partnerRequest = id === 'partner';
  const otherRequest = !investorRequest && !partnerRequest;

  return {
    message,
    investorRequest,
    partnerRequest,
    otherRequest,
    contact: rest,
  };
};
